/**
 * v-permission 指令
 * 用法：<el-button v-permission="'users:create'">新增用户</el-button>
 * 无权限时自动隐藏元素
 */
import type { Directive } from 'vue'
import { useAuthStore } from '@/store/auth'

export const vPermission: Directive = {
  mounted(el: HTMLElement, binding) {
    const perm = binding.value as string
    if (!perm) return
    const authStore = useAuthStore()
    if (!authStore.hasPermission(perm)) {
      el.style.display = 'none'
    }
  }
}

// 全局注册函数
export function registerPermission(app: any) {
  app.directive('permission', vPermission)
}
